/**
 * AYP年上年下恋爱倾向测试 - 题目数据
 * 
 * 包含4种测试类型的题目集合:
 * - self: 给自己测(新版)
 * - partner: 为恋人测(新版)
 * - self_new: 给自己测(原版)
 * - partner_new: 为恋人测(原版)
 * 
 * 每种测试包含4个维度,每个维度10题,共40题
 */

// 题目集合 - 按测试类型分组
export const QUESTION_SETS = {
  self: [
    {
      dimension: "成熟偏好",
      dimensionCode: "MAT",
      questions: [
        "当面对人生重要决定时,我内心渴望有人能给我明确的指引",
        "看到那些跨越年龄差距的恋情,我第一反应是羡慕他们的勇气",
        "在朋友聚会中,我通常更享受与阅历丰富的人深入交谈",
        "当伴侣的想法比我成熟很多时,我感到的是安心踏实",
        "我理想中的爱情更追求细水长流的稳定而非纯真热烈",
        "如果必须选择,我更倾向于'平淡安稳但可靠'的关系",
        "当遇到挫折时,我更希望伴侣像个导师一样指导我",
        "我认为'在爱情中成长'更多是被对方引领成长",
        "在亲密关系中,我更看重的是长远的可能性而非当下快乐",
        "当发现伴侣在某些方面远比我优秀时,我更多的是欣赏崇拜"
      ]
    },
    {
      dimension: "照顾需求",
      dimensionCode: "CAR",
      questions: [
        "在疲惫的一天结束后,我期待伴侣为我安排好一切",
        "当我生病时,我希望伴侣寸步不离地照顾我",
        "在重要的纪念日,我更在意精心准备的惊喜",
        "当我在工作中受挫,我更想听到'别担心有我'而非分析问题",
        "我认为在爱情中展现脆弱是自然的真情流露",
        "当我情绪低落时,我希望伴侣立即察觉并安慰我",
        "在旅行规划中,我更享受被安排得明明白白",
        "当与伴侣产生分歧时,我期待对方主动让步",
        "我理想中的关怀是事无巨细的呵护",
        "当我在新环境中感到不安时,我需要伴侣的保护"
      ]
    },
    {
      dimension: "引导欲望",
      dimensionCode: "GUI",
      questions: [
        "在尝试新事物时,我更享受带领伴侣探索",
        "当伴侣向我求助时,我内心的第一反应是责任感满满",
        "我更愿意做关系中的'定心丸'而非'开心果'",
        "看到伴侣因为我的建议而成长时,我感受到的是成就感",
        "在朋友眼中,我更像是那个照顾人的角色",
        "当规划未来时,我更倾向于主动提出想法",
        "我认为'保护欲'是爱的表现而非过度的控制",
        "在教导伴侣某件事情时,我更多的是耐心引导",
        "当伴侣依赖我时,我感受到被需要的美好",
        "我理想的关系模式是相互扶持共同进步"
      ]
    },
    {
      dimension: "独立倾向",
      dimensionCode: "IND",
      questions: [
        "即使恋爱中,我也需要独处的时间来充电",
        "当伴侣想融入我的朋友圈时,我感到些许不适",
        "我认为'我们'和'我'的平衡需要刻意维护的界限",
        "在做出人生重大决定时,我会优先跟随自己的内心",
        "当伴侣想了解我的每一个想法时,我感到被监视",
        "我理想中的亲密是保留神秘感的吸引",
        "当伴侣为我付出太多时,我感到的是压力",
        "在关系中,我更害怕失去自我而非失去对方",
        "我认为经济独立是爱情的基础",
        "当面临异地恋时,我期待距离产生的美"
      ]
    }
  ],
  partner: [
    {
      dimension: "恋人成熟偏好",
      dimensionCode: "MAT",
      questions: [
        "当面对人生重要决定时,我的恋人内心渴望有人能给TA明确的指引",
        "看到那些跨越年龄差距的恋情,我的恋人第一反应是羡慕他们的勇气",
        "在朋友聚会中,我的恋人通常更享受与阅历丰富的人深入交谈",
        "当我的想法比恋人成熟很多时,TA感到的是安心踏实",
        "我的恋人理想中的爱情更追求细水长流的稳定而非纯真热烈",
        "如果必须选择,我的恋人更倾向于'平淡安稳但可靠'的关系",
        "当遇到挫折时,我的恋人更希望我像个导师一样指导TA",
        "我的恋人认为'在爱情中成长'更多是被对方引领成长",
        "在亲密关系中,我的恋人更看重的是长远的可能性而非当下快乐",
        "当发现我在某些方面远比TA优秀时,我的恋人更多的是欣赏崇拜"
      ]
    },
    {
      dimension: "恋人照顾需求",
      dimensionCode: "CAR",
      questions: [
        "在疲惫的一天结束后,我的恋人期待我为TA安排好一切",
        "当TA生病时,我的恋人希望我寸步不离地照顾TA",
        "在重要的纪念日,我的恋人更在意精心准备的惊喜",
        "当TA在工作中受挫,我的恋人更想听到'别担心有我'而非分析问题",
        "我的恋人认为在爱情中展现脆弱是自然的真情流露",
        "当TA情绪低落时,我的恋人希望我立即察觉并安慰TA",
        "在旅行规划中,我的恋人更享受被安排得明明白白",
        "当与我产生分歧时,我的恋人期待我主动让步",
        "我的恋人理想中的关怀是事无巨细的呵护",
        "当TA在新环境中感到不安时,我的恋人需要我的保护"
      ]
    },
    {
      dimension: "恋人引导欲望",
      dimensionCode: "GUI",
      questions: [
        "在尝试新事物时,我的恋人更享受带领我探索",
        "当我向TA求助时,我的恋人内心的第一反应是责任感满满",
        "我的恋人更愿意做关系中的'定心丸'而非'开心果'",
        "看到我因为TA的建议而成长时,我的恋人感受到的是成就感",
        "在朋友眼中,我的恋人更像是那个照顾人的角色",
        "当规划未来时,我的恋人更倾向于主动提出想法",
        "我的恋人认为'保护欲'是爱的表现而非过度的控制",
        "在教导我某件事情时,我的恋人更多的是耐心引导",
        "当我依赖TA时,我的恋人感受到被需要的美好",
        "我的恋人理想的关系模式是相互扶持共同进步"
      ]
    },
    {
      dimension: "恋人独立倾向",
      dimensionCode: "IND",
      questions: [
        "即使恋爱中,我的恋人也需要独处的时间来充电",
        "当我想融入TA的朋友圈时,我的恋人感到些许不适",
        "我的恋人认为'我们'和'我'的平衡需要刻意维护的界限",
        "在做出人生重大决定时,我的恋人会优先跟随自己的内心",
        "当我想了解TA的每一个想法时,我的恋人感到被监视",
        "我的恋人理想中的亲密是保留神秘感的吸引",
        "当我为TA付出太多时,我的恋人感到的是压力",
        "在关系中,我的恋人更害怕失去自我而非失去对方",
        "我的恋人认为经济独立是爱情的基础",
        "当面临异地恋时,我的恋人期待距离产生的美"
      ]
    }
  ],
  self_new: [
    {
      dimension: "成熟偏好",
      dimensionCode: "MAT",
      questions: [
        "我更喜欢与比我年长的人建立恋爱关系",
        "年龄差距在恋爱关系中对我来说不是问题",
        "我喜欢与成熟稳重的人相处",
        "我觉得年长的伴侣更能给我安全感",
        "我容易被年长者的智慧和经验所吸引",
        "在与年长者相处时,我感到更舒适",
        "我认为年长的伴侣更懂得如何照顾人",
        "我认为年长的伴侣通常更懂得经营关系",
        "我认为年龄差距不会影响我们的沟通",
        "我认为年长的伴侣在经济和情感上更稳定"
      ]
    },
    {
      dimension: "照顾需求",
      dimensionCode: "CAR",
      questions: [
        "我希望在恋爱关系中能得到更多的照顾和关怀",
        "我喜欢被伴侣当作孩子一样宠爱",
        "在困难时,我希望伴侣能给我指导和建议",
        "我享受被伴侣保护和照顾的感觉",
        "我倾向于依赖伴侣做决定",
        "我喜欢伴侣为我安排好一切",
        "在恋爱中,我更喜欢扮演被照顾的角色",
        "我希望伴侣能包容我的任性和小脾气",
        "我习惯向伴侣寻求帮助和支持",
        "我觉得被照顾是恋爱中很重要的一部分"
      ]
    },
    {
      dimension: "引导欲望",
      dimensionCode: "GUI",
      questions: [
        "我喜欢在恋爱关系中引导对方",
        "我享受教导和培养伴侣的过程",
        "我希望伴侣能听从我的建议和指导",
        "我喜欢在关系中扮演保护者的角色",
        "我倾向于选择比我年轻的伴侣",
        "我觉得引导伴侣能让我有成就感",
        "我喜欢为伴侣规划未来",
        "我享受被伴侣依赖的感觉",
        "我认为在恋爱中,我应该承担更多的责任",
        "我喜欢照顾伴侣的生活起居"
      ]
    },
    {
      dimension: "独立倾向",
      dimensionCode: "IND",
      questions: [
        "我认为恋爱中双方都应该保持独立",
        "我不喜欢过于依赖伴侣",
        "我习惯自己处理问题,而不是依赖伴侣",
        "即使恋爱,我也需要足够的个人空间",
        "我不喜欢伴侣过多干涉我的生活",
        "我认为年龄差距不会影响我的独立性",
        "我更喜欢平等相处的恋爱关系",
        "我不希望伴侣把我当孩子一样照顾",
        "我习惯独立做决定",
        "我认为恋爱关系不应该束缚个人的自由"
      ]
    }
  ],
  partner_new: [
    {
      dimension: "恋人成熟偏好",
      dimensionCode: "MAT",
      questions: [
        "我的恋人更喜欢与比自己年长的人建立恋爱关系",
        "年龄差距在恋爱关系中对我的恋人来说不是问题",
        "我的恋人喜欢与成熟稳重的人相处",
        "我的恋人觉得年长的伴侣更能给TA安全感",
        "我的恋人容易被年长者的智慧和经验所吸引",
        "在与年长者相处时,我的恋人感到更舒适",
        "我的恋人认为年长的伴侣更懂得如何照顾人",
        "我的恋人认为年长的伴侣通常更懂得经营关系",
        "我的恋人认为年龄差距不会影响我们的沟通",
        "我的恋人认为年长的伴侣在经济和情感上更稳定"
      ]
    },
    {
      dimension: "恋人照顾需求",
      dimensionCode: "CAR",
      questions: [
        "我的恋人希望在恋爱关系中能得到更多的照顾和关怀",
        "我的恋人喜欢被当作孩子一样宠爱",
        "在困难时,我的恋人希望我能给TA指导和建议",
        "我的恋人享受被保护和照顾的感觉",
        "我的恋人倾向于依赖我做决定",
        "我的恋人喜欢我为TA安排好一切",
        "在恋爱中,我的恋人更喜欢扮演被照顾的角色",
        "我的恋人希望我能包容TA的任性和小脾气",
        "我的恋人习惯向我寻求帮助和支持",
        "我的恋人觉得被照顾是恋爱中很重要的一部分"
      ]
    },
    {
      dimension: "恋人引导欲望",
      dimensionCode: "GUI",
      questions: [
        "我的恋人喜欢在恋爱关系中引导对方",
        "我的恋人享受教导和培养伴侣的过程",
        "我的恋人希望我能听从TA的建议和指导",
        "我的恋人喜欢在关系中扮演保护者的角色",
        "我的恋人倾向于选择比自己年轻的伴侣",
        "我的恋人觉得引导伴侣能让TA有成就感",
        "我的恋人为我规划未来",
        "我的恋人享受被我依赖的感觉",
        "我的恋人认为在恋爱中,TA应该承担更多的责任",
        "我的恋人喜欢照顾我的生活起居"
      ]
    },
    {
      dimension: "恋人独立倾向",
      dimensionCode: "IND",
      questions: [
        "我的恋人认为恋爱中双方都应该保持独立",
        "我的恋人不喜欢过于依赖伴侣",
        "我的恋人习惯自己处理问题,而不是依赖伴侣",
        "即使恋爱,我的恋人也需要足够的个人空间",
        "我的恋人不喜欢我过多干涉TA的生活",
        "我的恋人认为年龄差距不会影响TA的独立性",
        "我的恋人更喜欢平等相处的恋爱关系",
        "我的恋人不希望我把TA当孩子一样照顾",
        "我的恋人习惯独立做决定",
        "我的恋人认为恋爱关系不应该束缚个人的自由"
      ]
    }
  ]
};

// 评分选项 (1-5分)
export const RATING_OPTIONS = [
  { value: 1, label: "非常不符合" },
  { value: 2, label: "不太符合" },
  { value: 3, label: "一般" },
  { value: 4, label: "比较符合" },
  { value: 5, label: "非常符合" }
];

// 测试类型定义
export const TEST_TYPES = {
  self: {
    key: 'self',
    label: '给自己测(新版)',
    description: '通过深度心理学问题,探索你在恋爱关系中的真实倾向',
    badge: '推荐',
    questionCount: 40,
    dimensionCount: 4
  },
  partner: {
    key: 'partner',
    label: '为恋人测(新版)',
    description: '从第三人称视角,评估恋人的年上年下倾向',
    badge: '推荐',
    questionCount: 40,
    dimensionCount: 4
  },
  self_new: {
    key: 'self_new',
    label: '给自己测(原版)',
    description: '经典版本,更直接的问题设计',
    badge: '经典',
    questionCount: 40,
    dimensionCount: 4
  },
  partner_new: {
    key: 'partner_new',
    label: '为恋人测(原版)',
    description: '经典版本,评估恋人的恋爱倾向',
    badge: '经典',
    questionCount: 40,
    dimensionCount: 4
  }
};

// 维度定义
export const DIMENSIONS = {
  MAT: {
    code: 'MAT',
    name: '成熟偏好',
    description: '对伴侣成熟度的偏好程度',
    highScore: '喜欢年长伴侣、渴望被指引、追求稳定安全感',
    lowScore: '对年龄差距不敏感、重视平等相处'
  },
  CAR: {
    code: 'CAR',
    name: '照顾需求',
    description: '在关系中被照顾的需求强度',
    highScore: '期待被呵护、享受被安排、希望伴侣察觉情绪',
    lowScore: '独立自主、不依赖伴侣照顾'
  },
  GUI: {
    code: 'GUI',
    name: '引导欲望',
    description: '在关系中引导和照顾对方的欲望',
    highScore: '喜欢引领伴侣、享受被依赖、责任感强',
    lowScore: '不倾向主导关系、更愿意跟随'
  },
  IND: {
    code: 'IND',
    name: '独立倾向',
    description: '在关系中保持独立性的需求',
    highScore: '需要个人空间、害怕失去自我、经济独立重要',
    lowScore: '愿意融合、不介意亲密无间'
  }
};

